exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "fi-image-editor-dialog {\n  display: block;\n}\nfi-image-editor-dialog .gallery-delete-icon {\n  margin: 15px 0 0 0 !important;\n}\nfi-image-editor-dialog .gallery-delete-icon md-icon {\n  font-size: 18px;\n  height: 18px;\n  width: 18px;\n  line-height: 18px;\n  min-width: 18px;\n  min-height: 18px;\n  user-select: none;\n}", ""]);

// exports
